import React from 'react';
import { ReactComponent as SearchIcon } from 'assets/icons/Search.svg';
import styles from './SearchInstallationInput.module.scss';

const SearchInstallationInput = (props: React.InputHTMLAttributes<HTMLInputElement>): JSX.Element => (
  <div className={styles.container}>
    <input type="text" {...props} />
    <SearchIcon />
  </div>
);
export default SearchInstallationInput;
